/**
 * 用户接口
 * 科大平台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../token/model/CreatedVo';
import LoginTokenVo from '../../token/model/LoginTokenVo';
import PwdLoginForm from '../../token/model/PwdLoginForm';
import ResetPwdBySmsForm from '../../token/model/ResetPwdBySmsForm';
import SendMsgForm from '../../token/model/SendMsgForm';
import SendMsgVo from '../../token/model/SendMsgVo';
import SmsSignupForm from '../../token/model/SmsSignupForm';
import UpdatedVo from '../../token/model/UpdatedVo';
  /**
   * UestcToken service.
   * @module token/api/UestcTokenApi
   * @version 0.2.0
   */

  /**
   * Constructs a new UestcTokenApi. 
   * @alias module:token/api/UestcTokenApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 注销删除账号
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/UpdatedVo}
     */
this.deleteAccount = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/uestc/token/delAccount', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 登录接口
     * @param {module:token/model/PwdLoginForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/LoginTokenVo}
     */
this.getTokenByPwd = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getTokenByPwd";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;
      isPublic = true;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = LoginTokenVo;
      return this.apiClient.callApi(
        '/api/uestc/token/pwd', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取当前登录用户信息
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/LoginTokenVo}
     */
this.getUserInfo = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = LoginTokenVo;
      return this.apiClient.callApi(
        '/api/uestc/token/current', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 手机号验证码重置密码
     * @param {module:token/model/ResetPwdBySmsForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/UpdatedVo}
     */
this.resetPwdBySms = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling resetPwdBySms";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;
      isPublic = true;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/uestc/token/reset_pwd_by_sms', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 发送手机验证码
     * @param {module:token/model/SendMsgForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/SendMsgVo}
     */
this.sendPhoneMsg = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sendPhoneMsg";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;
      isPublic = true;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = SendMsgVo;
      return this.apiClient.callApi(
        '/api/uestc/token/send_msg', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 手机号验证码注册
     * @param {module:token/model/SmsSignupForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:token/model/CreatedVo}
     */
this.signupBySms = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling signupBySms";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;
      isPublic = true;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/uestc/token/signup_by_sms', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
